import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { DataListComponent } from './data-list.component';
import { AlertMessageModule } from '../alert-message/alert-message.module';


@NgModule({
  declarations: [DataListComponent],
  exports: [DataListComponent],
  imports: [
    CommonModule,
    IonicModule,
    AlertMessageModule
  ]
})
export class DataListModule { }
